import React, { useState, useEffect } from "react";
import { Container, TextField, Card, Button, Typography, Grid, CardActions, LinearProgress, InputAdornment, Switch} from '@mui/material';
import { useNavigate } from "react-router-dom";
import CommonListHeader from "components/layout/list/header";
import { useSelector, useDispatch } from 'react-redux'
import { orgCreate, resetOrg } from 'api/org';
import { useOrgCreateMutation } from 'services/org'
import { v4 as uuidv4 } from 'uuid'
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';

const UsTiresCreate = (props) => {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const regexCode = /^[a-zA-Z0-9]{6,}$/;
    const navi = useNavigate();
    const dispatch = useDispatch();
    const org = useSelector(state=>state.org.create);
    const [disableButton, setDisableButton] = useState(false);
    
    const [validEmail, setValidEmail] = useState(false);
    const [invalidEmail, setInValidEmail] = useState(false);
    const [emailStatus, setEmailStatus] =  useState('');

    const [validCode, setValidCode] = useState(false);
    const [invalidCode, setInValidCode] = useState(false);
    const [codeStatus, setCodeStatus] =  useState('');

    const [ orgCreateMutation, { isLoading: isUpdating }] = useOrgCreateMutation(); 

    const handleCancel = () =>{
        navi("/orgs/list")
    }

    useEffect(()=>{
        dispatch(resetOrg())
    }, [])

    
    const onNameChange = (event) =>{
        dispatch(orgCreate({name: event.target.value}))
    }

    const onCodeChange = (event) =>{
        dispatch(orgCreate({code: event.target.value}))
    }

    const onCodeBlur = (event)=>{
        if(regexCode.test(event.target.value)){
            setInValidCode(false);
            setCodeStatus('');
            setValidCode(true);
        } else {
            setInValidCode(true);
            setCodeStatus('Invalid Code. Min 6 Alphanumric chars required.');
            setValidCode(false);
        }
    }

    const onEmailChange = (event) =>{
        dispatch(orgCreate({email: event.target.value}))
    }

    const onEmailBlur = (event) =>{
        
        if(regex.test(event.target.value)){
            setInValidEmail(false);
            setEmailStatus('')
            setValidEmail(true);
        } else {
            setInValidEmail(true);
            setEmailStatus('Invalid E-Mail')
            setValidEmail(false);
        }
    }

    const onPhoneChange = (value) =>{
        var phone = value;
        var phone_number = `+1${value}`;
        if(org.phone.length<11){
            dispatch(orgCreate({phone: phone}));
            dispatch(orgCreate({phone_number: phone_number}));
        }
    }

    const onStatusChange = (event) =>{
        dispatch(orgCreate({status: event.target.checked}))
    }

    const onSave = () =>{
        var id = uuidv4();
        var record = {
            ...org,
            id: id
        }
        if(validEmail && emailStatus===''){
            setDisableButton(true);
            orgCreateMutation(record)
            .unwrap()
            .then(result=>{
                setTimeout(()=>{
                    setDisableButton(false);
                    navi("/orgs/list");  
                }, 5000)
            })
            .catch(err=>{
                setDisableButton(false);
            })
        }
    }

    return (
        <React.Fragment>
            <CommonListHeader value = {{title: "Create New User", description: "Add new User"}} />
            <Container maxWidth={'md'}>
                <Card>
                    {disableButton?<LinearProgress />:''}
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Organization Name</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField 
                                variant="outlined" 
                                fullWidth
                                onChange={onNameChange}
                                value={org.name || ''}  
                            />
                        </Grid>
                    </Grid>
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Organization Code</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField 
                                variant="outlined" 
                                fullWidth
                                onChange={onCodeChange}
                                value={org.code || ''}  
                                helperText={codeStatus}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="start">
                                            {validCode?<DoneIcon color="primary" />:invalidCode?<CloseIcon color="warning" />:''}
                                        </InputAdornment>
                                    )
                                }}
                                onBlur={onCodeBlur}
                            />
                        </Grid>
                    </Grid>
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">E-Mail</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField 
                                variant="outlined" 
                                fullWidth
                                onChange={onEmailChange}
                                value={org.email || ''}  
                                helperText={emailStatus}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="start">
                                            {validEmail?<DoneIcon color="primary" />:invalidEmail?<CloseIcon color="warning" />:''}
                                        </InputAdornment>
                                    )
                                }}
                                onBlur={onEmailBlur}
                            />
                        </Grid>
                    </Grid>
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Phone</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField 
                                variant="outlined" 
                                type="number"
                                fullWidth
                                onChange={(event)=>onPhoneChange(event.target.value)}
                                value={org.phone || ''}  
                            />
                        </Grid>
                    </Grid>

                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Status</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <Switch checked={org?.status} onChange={(event)=>onStatusChange(event)}/>
                        </Grid>
                    </Grid>
                    
                    <CardActions sx={{padding: "15px"}}>
                        <Button
                            disabled={disableButton}
                            variant="contained"
                            color='primary'
                            type="submit"
                            onClick={() => onSave()}
                        >
                            Submit
                        </Button>
                        <Button
                            disabled={disableButton}
                            variant="outlined"
                            type="submit"
                            onClick={() => handleCancel()}
                        >
                            Cancel
                        </Button>
                    </CardActions>
                </Card>
            </Container>
        </React.Fragment>
    )

    
}

export default UsTiresCreate;